import { useQuery } from "@tanstack/react-query";
import { getAllPaabudIndberetninger } from "@/api/paabud";
import type { PaabudIndberetningOverviewModel } from "@/interfaces/paabud";

export const INJUNCTIONS_QUERY_KEY = ["cle-compliance", "injunctions"] as const;

export const useInjunctions = () => {
  return useQuery<PaabudIndberetningOverviewModel[]>({
    queryKey: INJUNCTIONS_QUERY_KEY,
    queryFn: getAllPaabudIndberetninger,
    staleTime: 5 * 60 * 1000,
  });
};
